export const headerContentMap = {
    solarRequestType: 'Bald geht es los mit Ihrer PV-Lösung',
    address: 'Standort Ihres Projekts',
    contactPerson: 'Ansprechperson des Projekts',
    email: 'Letzter Schritt'
};
export const titleMap = {
    solarRequestType: 'Ihr Weg zur Solar-Lösung',
    address: 'Für wen ist die PV-Anlage gedacht?',
    contactPerson: 'Persönlicher Kontakt',
    email: 'Ihr persönliches Angebot'
};
export const legalTextSnippets = [
    'Ich habe die ',
    'Datenschutzhinweise',
    ' zur Kenntnis genommen und kann meine Einwilligung jederzeit ohne Angabe von Gründen mit Wirkung für die Zukunft widerrufen.'
];
export const legalText = legalTextSnippets.join('');
export const marketingLegalTextSnippets = [
    '(optional) Ja, ich willige ein, dass mich die verbundenen ',
    'Unternehmen der LichtBlick Gruppe',
    ' über Strom-, E-Mobilitäts- und Gas-Produkte sowie über energienahe Produkte und Dienstleistungen (z.B. Smartmeter, Wallboxen, alternative Energieanlagen oder Energieberatung) sowie zu Marktforschungszwecken und zur Qualitätssicherung telefonisch oder per E-Mail kontaktieren und informieren.'
];
export const marketingLegalText = marketingLegalTextSnippets.join('');
export const SERVER_ERROR_MESSAGE = 'Hoppla, es gibt wohl eine technische Störung. Versuche es gerne etwas später noch einmal.';
export const CONNECTION_ERROR_MESSAGE = 'Hoppla, der Server scheint nicht erreichbar zu sein. Bitte überprüfe deine Internetverbindung oder versuche es einfach später noch einmal.';

//# sourceMappingURL=b2b-funnel-embed.content.js.map